<template>
    <Card :title="$t('labels.price_templates')">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-3" v-for="priceTemplate in priceTemplates">
                    <FormGroup :label="priceTemplate.name">
                        <Input
                            :model-value="product?.price_templates?.[priceTemplate.uuid]"
                            @update:model-value="product.price_templates[priceTemplate.uuid] = $event"
                            :disabled="priceTemplate.formula !== null && priceTemplate.formula !== ''"
                        />
                    </FormGroup>
                </div>
            </div>
        </div>
    </Card>
</template>
<script>
import Card from "../../../../../components/new/CardComponent.vue";
import FormGroup from "../../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../../components/new/form/Input.vue";

export default {
    name: "InternalProductPriceTemplatesPage",
    components: {
        Card, FormGroup, Input
    },
    props: {
        product: {
            type: Object
        },
        priceTemplates: {
            type: Array,
            default: () => []
        }
    },
    emits: ["update"]
}
</script>